import { useTranslation } from 'react-i18next';

/** Last-resort crash screen (Sentry ErrorBoundary / route boundary fallback). */
export function CrashFallback({
  onRetry,
  compact,
}: {
  onRetry?: () => void;
  /** Narrower card for in-layout route recovery (not full-screen). */
  compact?: boolean;
} = {}) {
  const { t } = useTranslation();
  return (
    <div
      className={
        compact
          ? 'flex w-full items-center justify-center px-4 py-16'
          : 'flex min-h-screen items-center justify-center px-4'
      }
    >
      <div className="w-full max-w-[400px] rounded-card border border-linea bg-superficie p-6 text-center">
        <p className="font-serif text-[18px] text-tinta">{t('common.crash.title')}</p>
        <p className="mt-2 text-[13px] leading-5 text-tinta-2">{t('common.crash.body')}</p>
        <button
          type="button"
          className="mt-5 inline-flex h-10 items-center justify-center rounded-lg bg-acento px-4 text-[13px] font-semibold text-white hover:bg-acento-tinta"
          onClick={() => (onRetry ? onRetry() : window.location.reload())}
        >
          {onRetry ? t('common.crash.retry') : t('common.crash.reload')}
        </button>
      </div>
    </div>
  );
}
